import type MailSearchStore from "./schema/MailSearchStore";
import { createStore } from "owa-satcheljs";
import getDefaultAdvancedSearchViewState from "owa-mail-advanced-search/lib/utils/getDefaultAdvancedSearchViewState";

export const defaultMailSearchStore: MailSearchStore = {
    toDate: undefined,
    fromDate: undefined,
    includeAttachments: false,
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (26,5): Type 'null' is not assignable to type 'SearchScope'.
    // @ts-expect-error
    initialSearchScope: null,
    currentlySelectedFolderId: "",
    isSearchHistoryDirty: false,
    searchNumber: 0,
    searchSortOrder: undefined,
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (26,5): Type 'null' is not assignable to type 'SearchScope'.
    // @ts-expect-error
    staticSearchScope: null,
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (46,5): Type 'null' is not assignable to type 'SearchScope[]'.
    // @ts-expect-error
    staticSearchScopeList: null,
    shouldShowAdvancedSearch: false,
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function getDefaultAdvancedSearchViewState called at module scope is not allowed. This may cause unwanted side effects. */
    advancedSearchViewState: getDefaultAdvancedSearchViewState(),
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function getDefaultAdvancedSearchViewState called at module scope is not allowed. This may cause unwanted side effects. */
    initialAdvancedSearchViewState: getDefaultAdvancedSearchViewState(),
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (59,5): Type 'null' is not assignable to type 'SearchProvider'.
    // @ts-expect-error
    provider: null,
    isAlterationRecourse: false,
    selectedMailboxInfo: undefined,
    lastSearchQueryText: "",
    selectedSuggestion: undefined,
    topResults: [],
    numberOfTopResultsShown: 0,
    isQueryNL: false,
    fromRefinerSelections: [],
    toRefinerSelections: [],
};

const initialStore = { ...defaultMailSearchStore };

export const getStore: () => MailSearchStore = createStore<MailSearchStore>("mailSearchStore", initialStore);
export default getStore;
